import type { ReactNode } from 'react';

export const Setting = ({
  title: settingTitle,
  description,
  children,
  id,
}: {
  title: string | ReactNode;
  description?: string | ReactNode;
  children?: ReactNode;
  /** Optional anchor id so other pages can deep-link to this setting (e.g. /settings?scrollTo=telegram). */
  id?: string;
}) => {
  return (
    <div
      id={id}
      className="grid scroll-mt-24 gap-x-6 gap-y-2 px-5 py-5 sm:grid-cols-[190px_1fr] sm:px-6"
    >
      <div className="space-y-1">
        <dt className="font-medium text-sm text-zinc-900 leading-6 dark:text-white">
          {settingTitle}
        </dt>
        {description && (
          <dd className="text-xs text-zinc-500 leading-5 dark:text-zinc-400">{description}</dd>
        )}
      </div>
      <dd className="min-w-0 text-sm text-zinc-700 leading-6 dark:text-zinc-200">{children}</dd>
    </div>
  );
};

export default Setting;
